module.exports = __webpack_public_path__ + "media/images/editorial-bbbff493b8d3385f4ee3ad7d71e7999c.png";